import type { TemplateKind } from './enums';

/**
 * Поля для підстановки в шаблони DOCX: `{назва_поля}` у тексті документа.
 * Списки — блоком `{#services}…{/services}` (кожен елемент має `name`, `unit`).
 */
export const TEMPLATE_FIELDS: Record<string, string> = {
  org_name: 'Назва організації',
  org_code: 'Код ЄДРПОУ організації',
  org_address: 'Адреса організації',
  org_signatory: 'Підписант від організації',
  org_city: 'Місто укладення',
  contract_number: 'Номер договору',
  contract_date: 'Дата підписання договору',
  contract_kind: 'Тип договору',
  starts_at: 'Дата початку',
  ends_at: 'Дата завершення (або «безстроково»)',
  employee_full_name: 'ПІБ працівника',
  employee_short_name: 'Прізвище та ініціали',
  employee_tax_id: 'РНОКПП',
  employee_birth_date: 'Дата народження',
  employee_address: 'Адреса',
  employee_phone: 'Телефон',
  employee_email: 'Email',
  employee_iban: 'IBAN',
  employee_bank: 'Банк',
  position: 'Посада',
  project_code: 'Код проєкту',
  project_name: 'Назва проєкту',
  donor: 'Донор',
  center: 'Гуманітарний центр',
  location: 'Місто роботи',
  fte: 'Ставка зайнятості (FTE)',
  rate: 'Сума ставки',
  rate_unit: 'Одиниця ставки (за місяць / годину / послугу)',
  currency: 'Валюта (грн)',
  total_cap: 'Гранична сума договору',
  duties: 'Функціональні обов’язки (текст)',
  terms: 'Особливі умови',
  amendment_number: 'Номер додаткової угоди',
  amendment_date: 'Дата додаткової угоди',
  amendment_text: 'Зміст додаткової угоди',
  act_number: 'Номер акта',
  act_date: 'Дата акта',
  act_period: 'Звітний період акта',
  act_total: 'Сума за актом',
  act_hours: 'Години за актом',
};

/** Які поля має сенс показувати як підказку для кожного типу шаблону. */
export const TEMPLATE_HINT_FIELDS: Record<TemplateKind, string[]> = {
  contract_employment: Object.keys(TEMPLATE_FIELDS).filter(
    (k) => !k.startsWith('amendment_') && !k.startsWith('act_'),
  ),
  contract_civil: Object.keys(TEMPLATE_FIELDS).filter(
    (k) => !k.startsWith('amendment_') && !k.startsWith('act_'),
  ),
  contract_fop: Object.keys(TEMPLATE_FIELDS).filter(
    (k) => !k.startsWith('amendment_') && !k.startsWith('act_'),
  ),
  amendment: Object.keys(TEMPLATE_FIELDS).filter((k) => !k.startsWith('act_')),
  service_act: Object.keys(TEMPLATE_FIELDS).filter((k) => !k.startsWith('amendment_')),
};
